import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms'
import { environment } from '../../../../../environments/environment'

import { AbcInput } from '../../../../common/interfaces/abc-input.interface'
import { SelectOption } from '../../../../common/interfaces/select-option.interface'

@Component({
  selector: 'abc-radio-input',
  templateUrl: './radio-input.component.html',
  styleUrls: ['./radio-input.component.scss']
})
export class RadioInputComponent implements OnChanges, AbcInput {
  @Input() label: string
  @Input() placeholder: string
  @Input() helpText: string
  @Input() initialValue: { value: string | number }
  @Input() selectOptions: SelectOption[]
  @Input() showErrors = false
  @Input() validators: ValidatorFn[] = []
  @Input() uniqueId: string

  @Output() valueChanged: EventEmitter<{
    value: string | number
  }> = new EventEmitter()

  form: UntypedFormGroup
  required: boolean

  isAlt: boolean = environment.isAltVersion

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnChanges(changes: SimpleChanges): void {
    // Prevent value from being reset if showErrors changes.
    if (
      Object.keys(changes).length === 1 &&
      Object.keys(changes)[0] === 'showErrors'
    ) {
      return
    }

    this.form = this.formBuilder.group({
      radio: [null, this.validators || []]
    })

    if (this.initialValue) {
      setTimeout(() => {
        this.form.get('radio').setValue(this.initialValue.value)
      })
    }

    this.required = this.validators.includes(Validators.required)
  }

  select(item: SelectOption) {
    if (item.disabled) {
      return
    }
    this.selectOptions.forEach((i) => {
      i.selected = false
    })

    item.selected = !item.selected
    this.valueChanged.emit({ value: item.value })
  }
}
